export default __webpack_public_path__ + "static/media/space-1.19013dda.svg";